<template>
  <div v-if="isAddress1">
    <template
      v-if="
        addressList.length === 0 &&
        fqdnList.length === 0 &&
        countryList.length === 0
      "
      >any</template
    >
    <template v-else>
      <p v-for="(e, i) in addressList" :key="`address_${i}`">
        {{ e.ipAddressName ? e.ipAddressName : e.ipAddress }}
      </p>
      <p v-for="(e, i) in fqdnList" :key="`fqdn_${i}`">
        {{ e.fqdnName ? e.fqdnName : e.fqdn }}
      </p>
      <p v-for="(e, i) in countryList" :key="`country_${i}`">
        {{ e.country }}
      </p>
    </template>
  </div>
  <div v-else>
    <template v-if="addressList.length === 0">any</template>
    <template v-else>
      <p v-for="(e, i) in addressList" :key="`address_${i}`">
        {{ e.ipAddressName ? e.ipAddressName : e.ipAddress }}
      </p>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { GetSrcAddress1, GetSrcAddress2 } from "@/apis/NwPolicyApi";

/** インターネットType1,4のポリシーの送信元アドレス表示が出来るコンポーネント */
export default defineComponent({
  name: "PolicySrcAddress",
  props: {
    /** 送信元アドレス */
    srcAddress: {
      type: Object as PropType<GetSrcAddress1 | GetSrcAddress2>,
      required: true,
    },
  },
  computed: {
    /** true: GetSrcAddress1, false: GetSrcAddress2 */
    isAddress1(): boolean {
      return (
        "srcFqdnList" in this.srcAddress && "srcCountryList" in this.srcAddress
      );
    },
    /** アドレス一覧を昇順でソートした一覧 */
    addressList(): GetSrcAddress1["srcAddressList"] {
      return [
        ...this.srcAddress.srcAddressList
          .filter((e) => e.ipAddress && !e.ipAddressName)
          .sortBy(["ipAddress", "asc"]),
        ...this.srcAddress.srcAddressList
          .filter((e) => e.ipAddressName)
          .sortBy(["ipAddressName", "asc"]),
      ];
    },
    /** FQDN一覧を昇順でソートした一覧. GetSrcAddress1では無い場合は空 */
    fqdnList(): GetSrcAddress1["srcFqdnList"] {
      if (this.isAddress1) {
        return (this.srcAddress as GetSrcAddress1).srcFqdnList.sortBy([
          (e) => e.fqdnName ?? e.fqdn,
          "asc",
        ]);
      } else {
        return [];
      }
    },
    /** 国一覧を昇順でソートした一覧. GetSrcAddress1では無い場合は空 */
    countryList(): GetSrcAddress1["srcCountryList"] {
      if (this.isAddress1) {
        return (this.srcAddress as GetSrcAddress1).srcCountryList.sortBy([
          "country",
          "asc",
        ]);
      } else {
        return [];
      }
    },
  },
});
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>
